import { render } from "./ThongTinKyLenh.vue?vue&type=template&id=a000c700"
import script from "./ThongTinKyLenh.vue?vue&type=script&lang=js"
export * from "./ThongTinKyLenh.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__